
import { PdfReport } from "Models/pdf.report";
import API from "../api";
import { AxiosResponse } from "axios";

const endpoint = "reports/crews";


export const ReportsDispatchService = {

  async generatePdf(options?: any): Promise<AxiosResponse<PdfReport[]>> {
    return await API.post(`/${endpoint}/generate`, {},{
      params: options,
    });
  },
};
